import { Component } from '@angular/core';

@Component({
  selector: 'app-form-box',
  standalone: true,
  imports: [],
  templateUrl: './form-box.component.html',
  styleUrl: './form-box.component.scss'
})
export class FormBoxComponent {

}
